import { Container, IDisposable } from '@cgs/wge';
import { EpicWinPopupController } from '../../common/slot/controllers/epic_win_popup_controller';
import { EpicWinPopupView } from '../../common/slot/views/epic_win_popup_view';
import { BasePopupComponent } from '../popups/base_popup_component';
import { EpicWinConfiguration } from './epic_win_configuration';

export interface EpicWinPopupProviderParams {
  configuration: EpicWinConfiguration;
  sceneName?: string;
  soundName?: string;
  startAfterShortWinLines?: boolean;
  featureName?: string[] | null;
  ignoreOnStartRespins?: boolean;
  stopBackgroundSound?: boolean;
}

export class EpicWinPopupProvider
  extends BasePopupComponent<EpicWinPopupView>
  implements IDisposable
{
  protected readonly container: Container;
  protected readonly startAfterShortWinLines: boolean;
  protected readonly ignoreOnStartRespins: boolean;
  protected readonly featureName: string[] | null;
  protected readonly configuration: EpicWinConfiguration;

  constructor(
    container: Container,
    protected readonly params: EpicWinPopupProviderParams
  ) {
    super(
      container,
      params.sceneName || 'slot/big_win/scene',
      false,
      params.soundName || 'slot/big_win/sound'
    );
    console.log('load ' + this.constructor.name);
    this.container = container;
    this.ignoreOnStartRespins = params.ignoreOnStartRespins || false;
    this.featureName = params.featureName || null;
    this.startAfterShortWinLines = params.startAfterShortWinLines || false;
    this.configuration = params.configuration;
    this.createController();
  }

  protected createController(): void {
    const view = new EpicWinPopupView(
      this.container,
      this.rootScene,
      this.popupScene,
      this.popupSoundScene!,
      this.configuration
    );
    this.popupController = new EpicWinPopupController(
      this.container,
      view,
      this.configuration,
      true,
      this.startAfterShortWinLines
    );
  }

  public dispose(): void {
    this.popupScene.deinitialize();
  }
}
